import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import {
    Text,
    TextField,
    TagAdd,
    StyledCard,
    StyledCardContent,
    KeyboardDatePicker,
    Span,
    Checkbox,
    IconButton,
    InfoCirCleIcon2,
    ActivityCard,
} from '../../index';

import { StyledLabel, StyledFormControl } from '../../Input/style';

import { ACTIVITIES } from '../../../constant';

const HelpPDF = '/resources/docs/MindGym_Help__Support_July_2023_Updated.pdf';

dayjs.extend(objectSupport);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

const MindGymSelectHomework = ({
    dateAndPeriodData,
    handleDateAndPeriodChange,
    loading,
    handleClickActivity,
    noAppointment,
    appointmentDate,
    selectedActivity,
}) => {
    const [minDate, setMinDate] = useState(undefined);
    const [maxDate, setMaxDate] = useState(undefined);

    useEffect(() => {
        // if no selectedActivity use startDate as minDate and endDate as maxDate
        if (_.isEmpty(selectedActivity)) {
            setMinDate(
                dateAndPeriodData.startDate ? dayjs(dateAndPeriodData.startDate) : undefined
            );
            setMaxDate(dateAndPeriodData.endDate ? dayjs(dateAndPeriodData.endDate) : undefined);

            return;
        }

        // if selectedActivity use selectedActivityMaxDate as minDate and selectedActivityMinDate as maxDate

        let selectedActivityMinDate;
        let selectedActivityMaxDate;

        selectedActivity.forEach((item) => {
            if (
                !selectedActivityMinDate ||
                dayjs(item.startDate).isBefore(selectedActivityMinDate, 'date')
            ) {
                selectedActivityMinDate = dayjs(item.startDate);
            }

            if (
                !selectedActivityMaxDate ||
                dayjs(item.endDate).isAfter(selectedActivityMaxDate, 'date')
            ) {
                selectedActivityMaxDate = dayjs(item.endDate);
            }
        });

        setMinDate(selectedActivityMaxDate);
        setMaxDate(selectedActivityMinDate);
    }, [dateAndPeriodData, selectedActivity]);

    const disableUntilNextFollowUp = useMemo(() => {
        try {
            if (!_.isEmpty(selectedActivity)) {
                return true;
            }

            if (!appointmentDate || !dateAndPeriodData?.startDate) {
                return false;
            }

            console.log('dayjs(appointmentDate).isBefore(dayjs(dateAndPeriodData?.startDate)',dayjs(appointmentDate).isBefore(dayjs(dateAndPeriodData?.startDate)))
            

            if (dayjs(appointmentDate).isBefore(dayjs(dateAndPeriodData?.startDate)) || dayjs(appointmentDate).format('DD/MM/YYYY') ===  dayjs(dateAndPeriodData?.startDate).format('DD/MM/YYYY')) {
                return true;
            }
        } catch (error) {
            console.log('disableUntilNextFollowUp error', error);
            return false;
        }
    }, [dateAndPeriodData, appointmentDate, selectedActivity]);

    const disableClickActivity = useMemo(() => {
        try {
            if (!dateAndPeriodData?.startDate || !dateAndPeriodData?.endDate) {
                return true;
            }

            if (
                !dayjs(dateAndPeriodData?.startDate).isValid() ||
                !dayjs(dateAndPeriodData?.endDate).isValid()
            ) {
                return true;
            }

            return false;
        } catch (error) {
            console.log('disableClickActivity', error);
            return true;
        }
    }, [dateAndPeriodData]);

    return (
        <div>
            <StyledCard>
                <StyledCardContent>
                    <Text $fontSize="16px" $medium>
                        Set Dates & Period
                    </Text>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2,272px)',
                            columnGap: '20px',
                        }}
                    >
                        <KeyboardDatePicker
                            id="startDate"
                            label={
                                <Span $color="black">
                                    Start Date <Span $color="pink">*</Span>
                                </Span>
                            }
                            minDate={dateAndPeriodData.endDate ? dayjs(dateAndPeriodData.startDate).subtract(6, 'month').isAfter(dayjs()) ? dayjs(dateAndPeriodData.startDate).subtract(6, 'month') : dayjs() : dayjs()   }
                            value={dateAndPeriodData.startDate}
                            onChange={(date) => {
                                handleDateAndPeriodChange('startDate', date)
                
                            }}
                            disabled={loading}
                        />
                        <KeyboardDatePicker
                            id="endDate"
                            label={
                                <Span $color="black">
                                    End Date <Span $color="pink">*</Span>
                                </Span>
                            }
                            minDate={dayjs(minDate).isAfter(dayjs()) ? minDate : dayjs()}
                            maxDate={dateAndPeriodData.startDate ? dayjs(dateAndPeriodData.startDate).add(6, 'month') : undefined}
                            value={dateAndPeriodData.endDate}
                            onChange={(date) => {
                                console.log('date',date);
                                
                                handleDateAndPeriodChange('endDate', date)
                            }}
                            disabled={loading}
                        />
                        <Checkbox
                            label={
                                <Span $fontSize="12px" style={{ marginLeft: '10px' }}>
                                    Apply this timeframe to all activities
                                </Span>
                            }
                            checked={dateAndPeriodData.applyAll}
                            name="applyAll"
                            onChange={(e) => {
                                handleDateAndPeriodChange('applyAll', e.target.checked);
                            }}
                            fill="primaryBlue"
                        />
                        <Checkbox
                            label={
                                <Span $fontSize="12px" style={{ marginLeft: '10px' }}>
                                    Until next follow up
                                </Span>
                            }
                            checked={dateAndPeriodData.untilNext}
                            name="untilNext"
                            onChange={(e) => {
                                handleDateAndPeriodChange('untilNext', e.target.checked);
                            }}
                            disabled={noAppointment || !appointmentDate || disableUntilNextFollowUp}
                            fill="primaryBlue"
                        />
                    </div>
                </StyledCardContent>
            </StyledCard>
            <div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '5px',
                        marginTop: '32px',
                        marginBottom: '23px',
                    }}
                >
                    <Text $fontSize="16px" $medium>
                        Select Activity
                    </Text>

                    <a
                        href={HelpPDF}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'flex' }}
                    >
                        <InfoCirCleIcon2 />
                    </a>
                </div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto',
                        columnGap: '24px',
                        rowGap: '16px',
                    }}
                >
                    {Object.keys(ACTIVITIES).map((type) => (
                        <ActivityCard
                            key={type}
                            data={ACTIVITIES[type]}
                            onClick={() => handleClickActivity(type)}
                            disabled={disableClickActivity}
                            isSelected={selectedActivity.some((a) => a.type === type)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

MindGymSelectHomework.propTypes = {
    dateAndPeriodData: PropTypes.object,
    handleDateAndPeriodChange: PropTypes.func,
};

export default MindGymSelectHomework;
